exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-container[data-v-3de8c22b]{position:relative;width:100%}.video-container .video[data-v-3de8c22b]{width:100%;border:1px solid #b4bccc}.video-container .del-button[data-v-3de8c22b]{position:absolute;bottom:10px;right:0}", ""]);

// exports
